<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Select/NewDSelectEditor'
export default {
  name: 'NewDColumnPCTemplateEditor',
  extends: compoment
}
</script>
